var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseButton',{staticClass:"flex items-center",attrs:{"type":"button","primary":"","outline":"","small":""},on:{"click":_vm.editAudience}},[_c('span',[_vm._v("Edit")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }